export default __webpack_public_path__ + "static/5-263fa838c15d8b5721eddae3ce52abde.svg";